<template>
  <v-container>
    <v-row
      align="center"
      justify="center"

    >
      <v-col md="6">
        <v-alert
          v-model="showError"
          type="error"
          transition="scale-transition"
        >
          {{ errorMessage }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row
      align="center"
      justify="center"

    >
      <v-col md="6">
        <v-toolbar
          color="primary"
          dark
        >
          <v-toolbar-title class="ml-0 pl-3">Complete R4 Registration</v-toolbar-title>
        </v-toolbar>
        <v-card>
          <v-card-title>
            <v-col class="text-md-center" >
              <h3 class="text-md-center">You are one step away!</h3>
            </v-col>
            <v-col class="text-md-center" >
              <p>Add required details and change your password.</p>
              <p>You can not login until this step is complete!</p>
            </v-col>

          </v-card-title>
          <v-card-text>
            <v-form
              ref="login-form"
              lazy-validation>
              <v-text-field
                v-model="name"
                label="Your Name"
                required />
              <v-text-field
                v-model="password"
                label="New Password"
                type="password"
                required />
              <v-text-field
                v-model="password_confirmation"
                label="New Password Confirmation"
                type="password"
                required />
              <v-text-field
                v-if="showMfaInput"
                v-model="mfaChallengeUserCode"
                label="MFA Challenge Code"
                />
              <v-btn
                v-if="showMfaInput"
                color="primary"
                @click.prevent="verifyMfaChallenge"
                class="mr-2"
                type="submit">Verify MFA Token</v-btn>

              <v-btn
                v-if="!showMfaInput"
                color="info"
                @click.prevent="completeRegistration"
                type="submit">Complete Registration</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-footer
      :fixed="fixed"
      app
    >
      <v-col class="text-md-center" >
        <span v-html="$copyright"></span>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data: function () {
    return {
      name: '',
      password: null,
      password_confirmation: null,
      showError: false,
      errorMessage: null,
      fixed: false,
      showMfaInput: false,
      mfaChallengeUserCode: null,
      mfaChallengeName: null,
      mfaChallengeParameters: null
    }
  },
  computed: {
    ...mapState({ auth_challenge_data: state => state.cognito.user_auth_challenge })
  },
  methods: {
    clearError: function () {
      this.errorMessage = null
    },
    completeRegistration: function () {
      const name = this.name
      const password = this.password
      const passwordConfirmation = this.password_confirmation

      if (password !== passwordConfirmation) {
        this.errorMessage = 'Passwords do not match'
        this.showError = true
      } else {
        this.$store
          .dispatch('completeSignup', {
            password: password,
            requiredAttributes: { name: name }
          })
          .then((authResponse) => {
            if (authResponse.mfaChallengeRequired) {
              this.showMfaInput = true
              this.mfaChallengeName = authResponse.ChallengeName
              this.mfaChallengeParameters = authResponse.ChallengeParameters
              this.mfaSession = authResponse.Session
              return
            }

            this.$router.push({ name: 'dashboard_path' })
          })
          .catch(err => {
            this.showError = true
            this.errorMessage = `Error Completing Signup. ${err.message}`
          })
      }
    },
    verifyMfaChallenge: function () {
      this.clearError()
      const username = this.auth_challenge_data.username
      this.$store
        .dispatch('verifyMfaChallenge', {
          ChallengeName: this.mfaChallengeName,
          mfaChallengeUserCode: this.mfaChallengeUserCode,
          username: username,
          Session: this.mfaSession
        })
        .then(cognitoUser => {
          this.$logger.trace('>> verifyMfaChallenge cognitoUser', cognitoUser)
          this.$router.push({ name: 'dashboard_path' })
        })
        .catch(error => {
          this.showError = true
          this.errorMessage = error.message
        })
    }
  }
}
</script>
<style>

</style>
